import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon } from 'lucide-react';
const names = ['María G.', 'Carlos R.', 'Laura M.', 'Diego S.', 'Valentina P.', 'Andrés L.', 'Camila F.', 'Martín H.', 'Sofía T.', 'Juan Pablo V.', 'Florencia D.', 'Sebastián A.', 'Luciana B.', 'Matías C.', 'Carolina E.', 'Federico N.', 'Paula K.', 'Nicolás J.', 'Agustina W.', 'Tomás Z.', 'Daniela O.', 'Alejandro Q.', 'Romina I.', 'Gonzalo U.', 'Micaela Y.'];
const cities = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Rosario, Argentina', 'Mendoza, Argentina', 'Tucumán, Argentina', 'Mar del Plata, Argentina', 'La Plata, Argentina', 'Salta, Argentina', 'Santa Fe, Argentina', 'Neuquén, Argentina', 'Bogotá, Colombia', 'Medellín, Colombia', 'Ciudad de México, México', 'Guadalajara, México', 'Lima, Perú', 'Santiago, Chile', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Asunción, Paraguay', 'San José, Costa Rica'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 45) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    function showPopup() {
      setData({
        name: getRandom(names),
        city: getRandom(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }
    // First popup after 8 seconds
    const initialTimeout = setTimeout(showPopup, 8000);
    // Then every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-16 md:bottom-6 left-4 z-[60] max-w-[320px] transition-all duration-500 ease-out" style={{
    transform: visible ? 'translateX(0)' : 'translateX(-120%)',
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? 'auto' : 'none'
  }} data-id="element-229">
      <div className="bg-white rounded-xl shadow-2xl shadow-black/30 p-3.5 flex items-start gap-3 border border-gray-100" data-id="element-230">
        <div className="w-9 h-9 rounded-full bg-green-100 flex items-center justify-center shrink-0" data-id="element-231">
          <ShoppingBagIcon size={18} className="text-green-600" data-id="element-232" />
        </div>
        <div className="min-w-0" data-id="element-233">
          <p className="text-gray-900 text-sm font-semibold leading-tight" data-id="element-234">
            {data.name}
          </p>
          <p className="text-gray-500 text-xs leading-snug mt-0.5" data-id="element-235">
            Compró{' '}
            <span className="font-medium text-gray-700" data-id="element-236">Matemática 360</span>
          </p>
          <p className="text-gray-400 text-[10px] mt-1" data-id="element-237">
            📍 {data.city} · hace {data.minutes} min
          </p>
        </div>
      </div>
    </div>;
}